import '@main';

u.on('product.item.loaded', function () {
  document.querySelector('.l-product-item')
    .classList.add('loaded')
})
